var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "trRep-edit__area table" },
    [
      _c("div", { staticClass: "trRep-edit__select" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "small-12 font-bold" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("username")) +
                " (" +
                _vm._s(_vm.$t("general.emailAddress")) +
                ")\n      "
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "small-4" },
            [
              _c("HKLSelect", {
                attrs: { options: _vm.candidateOpts, showSearch: true },
                on: { select: _vm.addSelectedUser },
              }),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("table", [
        _c("thead", [
          _c(
            "tr",
            [
              _vm._l(_vm.headers, function (ref, index) {
                var labelKey = ref.labelKey
                return _c("th", { key: index }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("table.header." + labelKey)) +
                      "\n        "
                  ),
                ])
              }),
              _vm._v(" "),
              _c("th"),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(_vm.selectedUsers, function (user, index) {
            return _c(
              "tr",
              { key: user.id },
              [
                _vm._l(_vm.headers, function (ref) {
                  var valueKey = ref.valueKey
                  return _c("td", { key: valueKey + "_" + index }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm._f("isEmptyValue")(user[valueKey])) +
                        "\n        "
                    ),
                  ])
                }),
                _vm._v(" "),
                user.id !== _vm.currentUser.id
                  ? _c(
                      "td",
                      [
                        _c("HKLDeleteIcon", {
                          on: {
                            click: function () {
                              return _vm.preDeleteUser(user, index)
                            },
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              2
            )
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _c("HKLModal", {
        ref: "delModalRef",
        on: {
          onOkClick: function () {
            return _vm.removeUser(_vm.pendingDelIndex)
          },
        },
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("hint.deleteTenancyRepresentative")) +
                    "\n    "
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }